import ali from './aliAuth.component';
import stAliButton from './aliButton.component';

export default angular
  .module('st.Integrations.Ali', ['st.Core', 'angular-cache'])
  .component('ali', ali)
  .component('stAliButton', stAliButton)
  .service('aliService', ($http, dataService, ALI) => ({
    refer: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        ALI.API.REFER,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('ALI', {
    API: {
      REFER: '/api/v1/integrations/ali/refer/'
    }
  });
